import React from 'react'
import '../../Styles/reports.css'
// import { ReportContextProvider } from '../../context/reportContext';
import Result from '../../Components/socialMedia/Result';



const SocialMedia = () => {
  return (
    <>
        <Result />
    </>
  )
}

export default SocialMedia